import { useAppSelector } from 'hooks/redux';
import AccessPermission from './access-permission';
import Jitsi from './jitsi';
import { RefObject } from 'react';
import { CDialogProps } from 'types/molecules';

type Props = {
  jitsiRef: RefObject<CDialogProps['jitsiRef']>;
};

export default function VideoCall({ jitsiRef }: Props) {
  const {
    isAccessGranted,

    appointmentDate,
    doctorCode,
    patientName,
    protocolNo,
    videoCallGroupId,
  } = useAppSelector((state) => state.app.videoCall);

  return (
    <>
      {isAccessGranted ? (
        <Jitsi
          appointmentDate={appointmentDate}
          doctorCode={doctorCode}
          patientName={patientName}
          protocolNo={protocolNo}
          videoCallGroupId={videoCallGroupId}
          ref={jitsiRef}
        />
      ) : (
        <AccessPermission />
      )}
    </>
  );
}

